<template>

    <div class="container">

        <app-head title="Categories" />

        <div class="my-4">
            <h1>{{ __('Kategorien') }}</h1>
        </div>
        <div class="row row-cols-1 row-cols-lg-2 g-4">
            <div class="col" v-for="category in categories">
                <div class="card h-100">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <img :src="category.image_url" class="img-fluid rounded-start" alt="" loading="lazy" />
                            </div>
                            <div class="col-md-9">
                                <h5 class="card-title">
                                    <inertia-link :href="category.permalink" class="link-dark">
                                        {{ category.name }}
                                    </inertia-link>
                                </h5>
                                <ul class="list-unstyled row row-cols-2 small">
                                    <li class="col" v-for="childCategory in category.children">
                                        <inertia-link :href="childCategory.permalink" class="" :title="childCategory.name">
                                            {{ childCategory.name }}
                                        </inertia-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import Breadcrumbs from '@/shared/Breadcrumbs';

    export default {
        props: [
            'categories',
        ],
        data() {
            return {
            }
        },
        components: {
            Breadcrumbs,
        }
    }
</script>